import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"],
  _excluded2 = ["children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useMemo } from 'react';
import { injectServices } from "./helpers";
import { CurrentProvider } from "./base.api";
var useBulkInjection = function useBulkInjection(injectables, concreteValues) {
  return useMemo(function () {
    return injectServices(injectables, concreteValues);
  }, Object.keys(injectables).map(function (key) {
    return concreteValues[key];
  }));
};
/**
 * A dictionary of selectors that must be injected
 * @param injectables - a dictionary of selectors/keys to be passed
 * @param options
 */
export function createCurrentModule(injectables) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var CurrentModule = function CurrentModule(_ref) {
    var children = _ref.children,
      concreteValues = _objectWithoutProperties(_ref, _excluded);
    var bulk = useBulkInjection(injectables, concreteValues);
    return /*#__PURE__*/React.createElement(CurrentProvider, {
      bulk: bulk,
      "data-t-id": "redux-current-src"
    }, typeof children === 'function' ? children(bulk) : children);
  };
  var CurrentModuleMapper = function CurrentModuleMapper(_ref2) {
    var children = _ref2.children,
      concreteValues = _objectWithoutProperties(_ref2, _excluded2);
    var primary = Object.keys(injectables).length === 1 ? Object.keys(injectables)[0] : options.primary;
    if (typeof primary === 'undefined') {
      throw new Error('Unable to use CurrentProvider.Mapper, when more than one selector is used, primary must be passed as second argument');
    }
    var primaryInjectable = injectables[primary],
      otherInjectables = _objectWithoutProperties(injectables, [primary].map(_toPropertyKey));
    var bulk = useBulkInjection(otherInjectables, concreteValues);
    return /*#__PURE__*/React.createElement(CurrentProvider.Mapper, {
      bulk: bulk,
      name: primaryInjectable,
      value: concreteValues[primary]
    }, typeof children === 'function' ? children(_objectSpread({}, bulk)) : children);
  };

  // const withCurrentModule: WithCurrentModuleType<BulkDataTypes, Primary> =
  //   (concreteValues) =>
  //   <P extends { [key in PropertyKey]: any }>(WrappedComponent: React.ComponentType<P>) => {
  //     const CurrentModuleRC = (props: P) => (
  //       <CurrentModule {...(concreteValues as any)}>
  //         <WrappedComponent {...props} />
  //       </CurrentModule>
  //     );
  //     const CurrentModuleMapperRC = (props: P) => (
  //       <CurrentModuleMapper {...(concreteValues as any)}>
  //         <WrappedComponent {...props} />
  //       </CurrentModuleMapper>
  //     );
  //     return Object.assign(CurrentModuleRC, { Mapper: CurrentModuleMapperRC });
  //   };
  //
  return Object.assign(CurrentModule, {
    Mapper: CurrentModuleMapper
    //   with: withCurrentModule,
  });
}